import React from 'react'
import Paper from '@material-ui/core/Paper'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  paper: {
    height: "100%",
    padding: theme.spacing(1)
  },
  gridItem: {
    marginLeft: '15px',
  }
})

const Card = ({ title, children, classes, isCustomStyle }) => {
  return (
    <Paper className={classNames(classes.paper, {[classes.gridItem]: isCustomStyle})}>
      {children}
    </Paper>
  )
}

export default withStyles(styles, {withTheme: true})(Card)